import { useBannerStore, BannerId } from '../../../stores/banner-store';

type UseBannerReturn = {
    isDismissed: boolean;
    dismiss: () => void;
    show: () => void;
};

function useBanner(bannerId: BannerId): UseBannerReturn {
    const { isBannerDismissed, dismissBanner, showBanner } = useBannerStore();

    return {
        isDismissed: isBannerDismissed(bannerId),
        dismiss: () => dismissBanner(bannerId),
        show: () => showBanner(bannerId),
    };
}

export { useBanner };
